import { createApp } from 'vue'

createApp(App).mount('#app')

import Vue from "vue";
import App from "./App.vue";

import { getAnalytics } from "firebase/analytics";

const analytics = getAnalytics(App);

console.log(analytics);

new Vue({
  
  render: h => h(App)
}).$mount("#app");